import { createNames } from "@ace/web-components/dist_lib/utils";
export const getAceBettingPromoCardNames = (id) => {
    return createNames(id, 'ACE-BETTING-PROMO-CARD', '____FULL_WIDTH', '____SPORTS_THEME', '____CONDENSED', 'CONTENT', 'CONDENSED_CONTENT', 'CONDENSED_TEXT', 'IMAGE', 'IMAGE_CONTAINER', 'ACTIONS', 'HEADLINE', 'BODY', 'BORDER');
};
//# sourceMappingURL=ace-betting-promo-card.get-names.js.map
